<template>
  <div>
    <gc-alert
      v-show="hasPersistedState"
      class="gc-mt-0 gc-mb-4 gc-text-left"
      type="info"
      text
    >
      <div
        class="gc-flex gc-flex-col sm:gc-flex-row gc-align-start sm:gc-items-center"
      >
        <p class="gc-mb-0">{{ $t('foundStateToRestore.message') }}</p>
        <gc-button
          color="info"
          class="gc-mt-4 sm:gc-mt-0 sm:gc-ml-4"
          @click="$emit('restore')"
        >
          {{ $t('foundStateToRestore.button') }}
          <font-awesome-icon :icon="faAngleRight" class="gc-ml-2" />
        </gc-button>
      </div>
    </gc-alert>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api';
import { faAngleRight } from '@fortawesome/pro-solid-svg-icons';
import GcButton from '@/components/primitives/GcButton.vue';
import GcAlert from '@/components/primitives/GcAlert.vue';

export default defineComponent({
  components: {
    GcAlert,
    GcButton,
  },
  props: {
    hasPersistedState: {
      default: false,
      type: Boolean,
    },
  },
  setup: () => ({
    faAngleRight,
  }),
});
</script>
